import React, { ReactElement, memo } from "react";
import {
  BrowserRouter as Router,
  Routes as RouterDom,
  Route,
  Navigate,
} from "react-router-dom";
import { Dashboard, ForgetPassword, LoginPage } from "components/src";
import { routesName, setAccessToken, storeToken } from "core";

interface Props {
  isLoggedIn?: boolean;
}

const Routes = memo<Props>(() => {
  const { accessToken } = storeToken.useState();
  
  const isLoggedIn = Boolean(accessToken);
  return (
    <Router>
      <RouterDom>
        <Route
          path={routesName.LOGIN}
          element={
            isLoggedIn ? <Navigate to={routesName.DASHBOARD} /> : <LoginPage />
          }
        />
        <Route path="/" element={<Navigate to={routesName.DASHBOARD} />} />
        <Route
          path={`${routesName.DASHBOARD}/*`}
          element={
            <ProtectedRoute {...{ isLoggedIn }}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path={routesName.FORGETPASSWORD} element={<ForgetPassword />} />
      </RouterDom>
    </Router>
  );
});

interface ProtectedRouteProps {
  children: ReactElement;
  isLoggedIn: boolean;
}

const ProtectedRoute = memo<ProtectedRouteProps>(({ children, isLoggedIn }) => {
  if (!isLoggedIn) {
    setAccessToken("");
  }
  return isLoggedIn ? children : <Navigate to={routesName.LOGIN} />;
});

export { Routes };
